export class BrownfieldBridgeError extends Error {
  constructor(
    message: string,
    public readonly code?: 'MODULE_UNAVAILABLE' | 'INVALID_TOKEN' | 'UNKNOWN',
    public readonly details?: unknown
  ) {
    super(message)

    this.name = 'BrownfieldBridgeError'
    this.code = code
    this.details = details

    Object.setPrototypeOf(this, BrownfieldBridgeError.prototype)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, BrownfieldBridgeError)
    }
  }
}
